import validate from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}